export default "__VITE_PUBLIC_ASSET__cea24bfe__"